<template>
    <b-modal id="modal-image-preview" scrollable :title="filename" hide-footer>
        <form class="form-horizontal form-material">
                <img class="images-preview-modal img-responsive" :src="url">
                <div class="img-caption"></div>
        </form>
    </b-modal>
</template>

<script>
    export default {
        props: ['url', 'filename']
    }
</script>